import type { SubscribePlanChangeUpgradeGet200ResponseUpgradeInfo } from './subscribePlanChangeUpgradeGet200ResponseUpgradeInfo';

export interface SubscribePlanChangeUpgradeGet200Response {
  message?: string;
  success: boolean;
  upgradeInfo?: SubscribePlanChangeUpgradeGet200ResponseUpgradeInfo;
}
